module.exports = __webpack_public_path__ + "static/media/robot.ef4525b1.mp3";